(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name flightWatch.controller:FlightWatchCtrl
   *
   * @description
   *
   */
  angular
    .module('flightWatch')
    .controller('FlightWatchCtrl', FlightWatchCtrl);

  function FlightWatchCtrl(FlightWatch, CommonMasterData, MessageService, EventManagerService, SlideInPanelService, $uibModal, PopupManager, applicationConstants) {
    var vm = this;
    vm.ctrlName = 'FlightWatchCtrl';
    vm.view = "FLIGHT_WATCH";

    vm.searchParams = null;

    vm.model = {
      airports: getAirportList(),
      baseType: getCrewBaseTypes(),
      aircraftTypes: getAirCraftTypes(),
      aircraftList: [],
      searchParam: '',
      rotationData: '',
      isFourDayView: false,
      viewMode: 'OneDay',
      openFlightData: [],
      openFlightButtonDisable: true,
      delayCodeDetails: [],
      currentTimeModel: [],
      fuelSuppliers: [],
      fullScheduleList: getNextCommingFullScheduleList(),
      savePriviledgeExist:false
    };
    vm.airCraftDetails = [];
    vm.isPopUpOpen = false;
    vm.refreshTime = [
      {value: '3', name: '3 mins'},
      {value: '5', name: '5 mins'},
      {value: '10', name: '10 mins'},
      {value: '15', name: '15 mins'}
    ];

    vm.popUpDetails = {};
    vm.popUpDetails.airCraftDetails = '';
    vm.popUpDetails.relatedAirCraft = '';
    vm.popUpDetails.approachTypes = '';
    vm.popUpDetails.rotationData = '';
    vm.selectedFlightLegDep = null;
    vm.selectedFlightLegOrigin = null;

    //getAirCraftTypes();
    vm.getSearchPanelData = function () {
      checkPrivilege();
      getAirportList();
      getCrewBaseTypes();
      getAirCraftTypes();
      getDelayCodeDetails();
      // getAircraftList();
    };

    function checkPrivilege() {
      FlightWatch.checkSavePriviledge(
        function (response) {
          vm.model.savePriviledgeExist = response.priviExists;
        }, function () {

        }
      )
    }

    function getAirportList() {

      CommonMasterData.getAirportList(
        function (response) {
          vm.model.airports = response;
        }, function () {

        }
      )
    }

    function getCrewBaseTypes() {
      CommonMasterData.getCrewBaseList(
        function (crewBase) {
          vm.model.baseType = crewBase;
        }, function () {

        }
      )
    }

    function getAircraftList() {
      var param = {
        pageSize: 200,
        startPosition: 0

      };
      CommonMasterData.getAircraftList(param,
        function (aircraft) {
          vm.model.aircraftList = aircraft;
        }, function () {

        }
      )

    }

    function getDelayCodeDetails() {
      CommonMasterData.getDelayCodeDetails(
        function (response) {
          vm.model.delayCodeDetails = response.delayCodeAdaptDTOs;
        }, function () {

        }
      )
    };

    function getAirCraftTypes() {
      CommonMasterData.getAircraftTypeList(
        function (aircrafts) {
          vm.model.aircraftTypes = aircrafts;
        },
        function () {
          console.log('Aircraft type retrieval error');
        }
      );
    }

    function getNextCommingFullScheduleList() {
      CommonMasterData.getNextCommingFullScheduleList(
        function (fullScheduleList) {
          vm.model.fullScheduleList = fullScheduleList;
        },
        function () {
          console.log('Full Schedule List retrieval error');
        }
      );
    }

    vm.animationsEnabled = true;

    EventManagerService.registerEventListener(EventManagerService.EVENT.SPACEBAR.CONFIG_AUTO_ROTATION, showConfigAutoRotationPopUp);

//        handle view mode changes
    EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.VIEW_MODE_CHANGE, changeViewMode);
    EventManagerService.registerEventListener(EventManagerService.EVENT.UPDATE_FLIGHT_DETAILS.UPDATE_FLIGHT, changeFlightData);
    EventManagerService.registerEventListener(EventManagerService.EVENT.UPDATE_FLIGHT_DETAILS.UPDATE_ROTATION, loadFlightRotationData);
    EventManagerService.registerEventListener(EventManagerService.EVENT.UPDATE_FLIGHT_DETAILS.CANCEL_FLIGHT, cancelFlight);


//        handle update flight event
    EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.UPDATE_FLIGHT, function (data) {
      vm.selectedAirCraft = data.items.pairDetails;
      vm.slectedFlightLegId = data.items.pairDetails.flightLegId;
      vm.loadFightDetails();
    });

//  handle update flight delete event

    EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.DELETE_FLIGHT, function (data) {
    	deleteFlightData(data);
    });

    EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.DELETE_CHECK, function (data) {
    	deleteCheckData(data);
    });

    EventManagerService.registerEventListener("remove.flight.leg.from.rotation", function (data) {
    	removeFlightPairFromAircraft(data);
    });

    EventManagerService.registerEventListener("add.flight.leg.to.rotation", function (data) {
    	addFlightPairToAircraft(data);
    });

//        handle send notification event
/*
    EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.SEND_CREW_NOTIFICATION, function (data) {
      vm.selectedAirCraft = data.items.pairDetails;
      vm.slectedFlightLegId = data.items.pairDetails.flightLegId;
      vm.selectedFlightLegOrigin = data.items.pairDetails.origin;
      vm.selectedFlightLegDep = data.items.pairDetails.destination;
      vm.loadSelectedFlightLegDetails();
    });
*/


    vm.toggleAnimation = function () {
      vm.animationsEnabled = !vm.animationsEnabled;
    };

    // flight update popup open
    vm.openPopUP = function (size) {
      vm.popUpDetails.close = 'CLOSE'
      PopupManager.openModal('FLIGHT_UPDATE_POPUP', vm.popUpDetails, updateFlightRotationData);
    };

    // send crew notification popup
    vm.openCrewNotificationPopUp = function () {
      PopupManager.openModal('FLIGHT_SEND_NOTIFICATION', vm.popUpDetails, null);
    };

    // load flight details by flightLegId
    vm.loadFightDetails = function () {
      FlightWatch.getAirCraftDetails(vm.slectedFlightLegId,
        function (response) {
          vm.popUpDetails.airCraftDetails = response.flightDetResponceDto;
          //vm.selectedFlightLegOrigin=vm.popUpDetails.airCraftDetails.originApt;
          vm.popUpDetails.fuelSuppliers = vm.model.fuelSuppliers;
          vm.popUpDetails.airports = vm.model.airports;
          vm.popUpDetails.delayCodeDetails = response.delayCodeAdaptDTOs;
          vm.popUpDetails.updateFlightSource = applicationConstants.UPDATE_FLIGHT_SOURCE.FLIGHT_WATCH;
          FlightWatch.loadAircraftListByCode(vm.selectedAirCraft.modelNo,
            function (response) {
              vm.popUpDetails.relatedAirCraft = response;
              CommonMasterData.approachTypes(
                function (response) {
                  vm.popUpDetails.approachTypes = response;
                  vm.openPopUP();
                }, function () {

                }
              );
            },
            function () {
              console.log('Open Flight search retrieval error');
            })

        },
        function (response) {

        }
      );
    };


//      load flight flightleg/legs details for send crew notifications
    vm.loadSelectedFlightLegDetails = function () {

      FlightWatch.getAirCraftDetails(vm.slectedFlightLegId,
        function (response) {
          vm.popUpDetails.airCraftDetails = response.flightDetResponceDto;
          vm.selectedFlightLegOrigin = vm.popUpDetails.airCraftDetails.originApt;
          vm.popUpDetails.fuelSuppliers = vm.model.fuelSuppliers;
          vm.popUpDetails.airports = vm.model.airports;
          vm.popUpDetails.delayCodeDetails = response.delayCodeAdaptDTOs;
          FlightWatch.loadAircraftListByCode(vm.selectedAirCraft.modelNo,
            function (response) {
              vm.popUpDetails.relatedAirCraft = response;
              CommonMasterData.approachTypes(
                function (response) {
                  vm.popUpDetails.approachTypes = response;
                 // vm.openCrewNotificationPopUp();
                }, function () {

                }
              );
            },
            function () {
              console.log('Open Flight search retrieval error');
            })

        },
        function (response) {

        }
      );


     // vm.openCrewNotificationPopUp();
    }

    vm.selectMultipleFlightLegs = function () {

    }


    //search flight watch details
    vm.onSearchFlightSchedule = function (searchParam) {
      vm.model.searchParam = FlightWatch.getFlightWatchSearchPram(searchParam);
      vm.model.openFlightButtonDisable = false;
      //load aircraft list
      FlightWatch.loadAircraftListByCode(vm.model.searchParam.aircraftModel,
        function (response) {
          vm.model.aircraftList = response;
          if (vm.model.aircraftList.length) {
            loadFlightRotationData();
          }
          else {
            vm.model.aircraftList = '';
            vm.model.rotationData = '';
            vm.model.openFlightData = '';
            vm.model.openFlightButtonDisable = true;
            MessageService.error('Aircraft model not found');
          }

        },
        function () {
          console.log('Open Flight search retrieval error');
        }
      );

    };

    //when refresh/reloading flight watch details
    vm.reloadSearchFlightRotationData = function () {
      loadFlightRotationData();
    };
//        search rotation data
//        formDate, toDate mandatory
    function loadFlightRotationData() {
      vm.model.openFlightButtonDisable = false;
      vm.model.searchParam = FlightWatch.getFlightWatchSearchPram(vm.searchParams);
      FlightWatch.searchFlightPairsSchedule(vm.model.searchParam,
        function (response) {
          if (response.success) {
            vm.model.rotationData = FlightWatch.flightWatchPairsAdaptor(response, response.aircrafts);
            vm.model.openFlightData = FlightWatch.flightWatchOpenFlightPairsAdaptor(response.openFlights);


            vm.popUpDetails.rotationData = vm.model.rotationData;

             EventManagerService.notifyEventListeners("show.open.flight.view", true);

            angular.element('.right-section').scrollLeft(0);
            angular.element('.left-section').scrollTop(0);
            loadCurrentTime();
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.FLIGHT_WATCH.SEARCH);
          }

        },
        function (response) {
          vm.model.rotationData = '';
          vm.model.openFlightData = '';
          vm.popUpDetails.rotationData = '';
          MessageService.warning(response[0]);
        }
      );
    };

    EventManagerService.registerEventListener(EventManagerService.EVENT.SPACEBAR.RUN_NEW_ROTATION, runNewRotation);

    function runNewRotation(param) {
      if (param.isFullSheduleRotation) {
        doFullScheduleRotation(param);
      } else {
        doDailyRotation(param);
      }
    }

    function setSearchPanel(param) {
      vm.searchParams = FlightWatch.setValuesToSearchParam(param, vm.model.aircraftTypes, vm.model.baseType);
      vm.model.searchParam = FlightWatch.getFlightWatchSearchPram(vm.searchParams);
      EventManagerService.notifyEventListeners(EventManagerService.EVENT.SPACEBAR.SET_SEARCH_PARAM, vm.searchParams);
    }

    function doDailyRotation(param) {
      setSearchPanel(param);
      var dailyRotationRq = FlightWatch.getDailyRotationSearchPram(param);
      FlightWatch.doDailyRotation(dailyRotationRq,
        function (response) {
          if (response.success) {
            vm.model.openFlightButtonDisable = false;

            vm.model.rotationData = FlightWatch.flightWatchPairsAdaptor(response, response.aircrafts);
            vm.model.openFlightData = FlightWatch.flightWatchOpenFlightPairsAdaptor(response.openFlights);

            EventManagerService.notifyEventListeners("set.flight.rotation", response.flightPairs);
            angular.element('.right-section').scrollLeft(0);
            angular.element('.left-section').scrollTop(0);
            loadCurrentTime();

            if (vm.model.openFlightData !== null && response.openFlights.length > 0) {
              EventManagerService.notifyEventListeners("show.open.flight.view", true);
            } else {
              EventManagerService.notifyEventListeners("show.open.flight.view", false);
            }
          }
        }, function (error) {
          vm.model.rotationData = '';
          vm.model.openFlightData = '';
          vm.popUpDetails.rotationData = '';

          vm.model.openFlightButtonDisable = true;
          EventManagerService.notifyEventListeners("show.open.flight.view", false);
          MessageService.error(error[0]);
        }
      );
    }

    function doFullScheduleRotation(param) {
      var fullRotationRq = FlightWatch.getFullScheduleRotationSearchPram(param);
      FlightWatch.doFullScheduleRotation(fullRotationRq,
        function (response) {
          if (response.success) {
            MessageService.success(MessageService.MESSAGES.FLIGHT.FULL_SCHD_ROTATION_SUCCESS);
            loadFlightRotationData();
          }
        }, function (error) {
          MessageService.error(error[0]);
        }
      );
    }

    vm.onSearchOpenFlight = function () {
      loadOpenFlights(false);
    };
    vm.reloadOpenFlight = function () {
      loadOpenFlights(true);
    };

//        load open flights
//        formDate, toDate mandatory
    function loadOpenFlights(showLoading) {
      if (!!showLoading) {
        showHideOpenFlightLoading(true);
      }
      FlightWatch.searchOpenFlightsSchedule(vm.model.searchParam, !showLoading,
        function (response) {
          vm.model.openFlightData = response.flightPairs;
          showHideOpenFlightLoading(false);
        },
        function (response) {
          showHideOpenFlightLoading(false);
          vm.model.openFlightData = '';
          MessageService.warning(response[0]);
        }
      );
    }

    function showHideOpenFlightLoading(flag) {
      EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, {
        flag: flag,
        target: 'openFlightLoading',
        animationName: 'crewing-loader'
      });
    };

    function changeViewMode() {
      vm.model.isFourDayView = !vm.model.isFourDayView;
      if (vm.model.isFourDayView) {
        vm.model.viewMode = "FourDay";
      }
      else {
        vm.model.viewMode = "OneDay";
      }
    }

    vm.sendRotationChangeEmail = function () {
      vm.model.searchParam = FlightWatch.getFlightWatchSearchPram(vm.searchParams);
      /*if(!validateSendEmailRequest()){
            return MessageService.error('From date and To date cannot be blank');
        }*/
      FlightWatch.sendRotationChangeEmail(vm.model.searchParam,
        function (response) {
          MessageService.success(MessageService.MESSAGES.FLIGHT.EMAIL_SENT_SUCCESS);
        },
        function () {
          MessageService.error('send rotation change email error');
        });
    };

    vm.sendRotationEmail = function () {

      vm.model.searchParam = FlightWatch.getFlightWatchSearchPram(vm.searchParams);

      FlightWatch.sendRotationEmail(vm.model.searchParam,
        function (response) {
          MessageService.success(MessageService.MESSAGES.FLIGHT.EMAIL_SENT_SUCCESS);
        },
        function () {
          console.log('send rotation email error');
        });
    }

    function changeFlightData(data) {

      if (data.currentAircraftRegistrationId !== vm.selectedAirCraft.aircraftId) {
        var temp = _.findWhere(vm.model.rotationData, {registrationID: vm.selectedAirCraft.aircraftId});
        var selectedPair = [];
        selectedPair.left = null;
        selectedPair.right = null;

        var rotationStatus = 'left';
        for (var i = 0; i < temp.pairs.length; i++) {
          if (temp.pairs[i].left != null) {
            for (var j = 0; j < temp.pairs[i].left.length; j++) {
              if (temp.pairs[i].left[j].flightLegId === data.flightLegId) {
                rotationStatus = 'left';
                var pair = temp.pairs[i].left.splice(j, 1);
                //selectedPair = {};
                selectedPair.left = pair;
                selectedPair.leftPos = temp.pairs[i].leftPos;
                selectedPair.rowIndex = temp.pairs[i].rowIndex;
                selectedPair.top = temp.pairs[i].top;
                selectedPair.widthInPx = temp.pairs[i].widthInPx;
                break;
              }

            }
          }
          if (!!temp.pairs[i] && temp.pairs[i].right != null) {
            for (var k = 0; k < temp.pairs[i].right.length; k++) {
              if (temp.pairs[i].right[k].flightLegId === data.flightLegId) {
                rotationStatus = 'right';

                var pair = temp.pairs[i].right.splice(k, 1);
                //selectedPair = {};
                selectedPair.right = pair;
                selectedPair.leftPos = temp.pairs[i].leftPos;
                selectedPair.rowIndex = temp.pairs[i].rowIndex;
                selectedPair.top = temp.pairs[i].top;
                selectedPair.widthInPx = temp.pairs[i].widthInPx;
                break;
              }
            }
          }
        }
        if (!!selectedPair) {
          if (selectedPair.left != null) {
            for (var j = 0; j < selectedPair.left.length; j++) {
              selectedPair.left[j].aircraftId = data.currentAircraftRegistrationId;
            }
          }
          if (selectedPair.right != null) {
            for (var k = 0; k < selectedPair.right.length; k++) {
              selectedPair.right[k].aircraftId = data.currentAircraftRegistrationId;
            }
          }
        }
        var current = _.findWhere(vm.model.rotationData, {registrationID: data.currentAircraftRegistrationId});
        current.pairs.push(selectedPair);
      }


    }


    function searchFlightPair(flightPairs,legId){

    	var selectedFlightPair = null;

    	if(flightPairs){
    		 angular.forEach(flightPairs, function (flightPair) {

    			var leftFlight = _.findWhere(flightPair.left, {flightLegId: legId});
    			if(leftFlight){
    				selectedFlightPair = flightPair;
    				return;
    			}

    			var rightFlight = _.findWhere(flightPair.right, {flightLegId: legId});
    			if(rightFlight){
    				selectedFlightPair = flightPair;
    				return;
    			}

 	        });
    	}

    	return selectedFlightPair;
    }


    function addFlightPairToOpenFlightList(flightPair){
    	var tempArray = [];
    	tempArray.push(flightPair);
    	var openFlights = FlightWatch.FlightPairToOpenFlight(tempArray);

    	angular.forEach(openFlights, function (openFlight) {
    		angular.forEach(openFlight.left, function (left) {
        		left.openBackgroundColour = '#778590';
    	    });

        	angular.forEach(openFlight.right, function (right) {
        		right.openBackgroundColour = '#778590';
    	    });
	    })

    	angular.forEach(openFlights, function (openFlight) {
    		 vm.model.openFlightData.push(openFlight);
    	 });

    }

    function removeFlightPairFromRotation(flightPair,rotationInfo){
    	if(flightPair){
    		var flightPairIndex = _.indexOf(rotationInfo.pairs,flightPair);
    		rotationInfo.pairs.splice( flightPairIndex, 1 ,{});
    	}
    }

    function deleteFlightData(data) {

    	var rotationInfo =_.findWhere(vm.model.rotationData, {registrationID: data.items.pairDetails.aircraftId});

    	if(rotationInfo && rotationInfo.pairs){
    		var flightPair = searchFlightPair(rotationInfo.pairs,data.items.pairDetails.flightLegId);
    		removeFlightPairFromRotation(flightPair,rotationInfo);
    		updateFlightPairDetailsAsChanged(flightPair);
    		addFlightPairToOpenFlightList(flightPair);
    	}

    }

    function cancelFlight(data) {
      angular.forEach(vm.model.rotationData, function (aircraft) {
        angular.forEach(aircraft.pairs, function (pair) {
          if(!(pair.left === null || pair.left === undefined || pair.left.length === 0)) {
            if (pair.left[0].flightLegId == data.flightLegId) {
              pair.left = null;
            }
          }

          if(!(pair.right === null || pair.right === undefined || pair.right.length === 0)) {
            if (pair.right[0].flightLegId == data.flightLegId) {
              pair.right = null;
            }
          }
        });
      });
    }

    function updateFlightPairDetailsAsChanged(flightPair) {

    	if(flightPair){

    		var flightPairArray = [];

        	angular.forEach(flightPair.left, function (left) {
        		left.aircraftId = 0;
    	    });

        	angular.forEach(flightPair.right, function (right) {
        		right.aircraftId = 0;
    	    });

        	flightPairArray.push(flightPair);

        	EventManagerService.notifyEventListeners("set.flight.rotation", flightPairArray);

    	}

    }

    function removeFlightPairFromAircraft(data) {

    	var rotationInfo =_.findWhere(vm.model.rotationData, {registrationID: data.aircraftId});

    	if(rotationInfo && rotationInfo.pairs){
    		var flightPair = searchFlightPair(rotationInfo.pairs,data.flightLegId);
    		removeFlightPairFromRotation(flightPair,rotationInfo);
    	}
    }

    function updateFlightRotationData(param) {

     if(param == 'CLOSE'){
    	return;
     }

//      if (param) {
//        var temp = _.findWhere(vm.model.rotationData, {registrationID: vm.selectedAirCraft.aircraftId});
//        for (var i = 0; i < temp.pairs.length; i++) {
//          if (temp.pairs[i].left != null) {
//            for (var j = 0; j < temp.pairs[i].left.length; j++) {
//              if (temp.pairs[i].left[j].flightLegId === param) {
//                temp.pairs[i].left.splice(j, 1);
//                break;
//              }
//
//            }
//          }
//          if (temp.pairs[i].right != null) {
//            for (var k = 0; k < temp.pairs[i].right.length; k++) {
//              if (temp.pairs[i].right[k].flightLegId === param) {
//                temp.pairs[i].right.splice(k, 1);
//                break;
//              }
//            }
//          }
//        }
//      }

    }


    function deleteCheckData(data) {

    	var check = data.items.$parent.check;

    	var rotationInfo =_.findWhere(vm.model.rotationData, {registrationID: check.aircraftRegId});

    	if(rotationInfo.checks){
    	  var aircraftCheck	= _.findWhere(rotationInfo.checks, {aircraftRegCheckId: check.aircraftRegCheckId});
    	  removeAircraftCheckFromRotation(aircraftCheck,rotationInfo);
    	  updateAircraftCheckDetailsAsChanged(aircraftCheck);
    	}

    }

    function removeAircraftCheckFromRotation(aircraftCheck,rotationInfo){
    	if(aircraftCheck){
    		var aircraftCheckIndex = _.indexOf(rotationInfo.checks,aircraftCheck);
    		rotationInfo.checks.splice( aircraftCheckIndex, 1 );
    	}
    }


    function updateAircraftCheckDetailsAsChanged(aircraftCheck) {
    	if(aircraftCheck){
        	EventManagerService.notifyEventListeners(EventManagerService.EVENT.CONTEXT_MENU.UPDATE_DELETE_CHECK_LIST, aircraftCheck);
    	}

    }

    function addFlightPairToAircraft(data) {

    	var rotationInfo =_.findWhere(vm.model.rotationData, {registrationID: data.aircraftId});

    	if(rotationInfo){
    		rotationInfo.pairs.push(data.flightPair);
    	}
    }


    function loadCurrentTime() {
      CommonMasterData.getCurrentTime(vm.model.searchParam.timeZone,
        function (response) {
          vm.model.currentTimeModel = response;
        }, function () {

        }
      );
    }


    function showConfigAutoRotationPopUp(){
    	var modalParam = {
				fullScheduleList : vm.model.fullScheduleList,
				acTypes : vm.model.aircraftTypes,
				bases : vm.model.baseType ,
				searchParams : vm.searchParams
		 };
		PopupManager.openModal('CONFIG_ROTATION_POPUP',modalParam, closedSummaryPopUp);
    }

    function closedSummaryPopUp() {
	}


  }

  $(window).resize(function () {
    if ($(".tabbed-view-container").height() < 40) {
      $(".tabbed-view-container").css("height", 40);
    }
    var height = Math.max($("header").height() + $(".tabbed-view-container").height(), 110) + "px";
    $(".flight-watch-view .canvas").css("top", height);
  });

}());
